<template>
    <project-step-container
            prev-to="js_rapid_experiments_with_customers_17"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
            :next-disabled="form.answer === null"
    >
        <b-row>
            <b-col cols="12" class="main-text" tabindex="0">
              {{getMessage(18, 'rapidexperiment-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="12" class="mt-2">
                <label for="first-thing"> {{getMessage(18, 'interview')}}</label>
                <input id="first-thing" type="text" v-model="form.interview"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing"> {{getMessage(18, 'find')}}</label>
                <textarea id="second-thing" type="text" v-model="form.find" rows="3"></textarea>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(18, 'mostappealing')}}</label>
                <textarea id="third-thing" type="text" v-model="form.mostappealing" rows="3"></textarea>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="four-thing">
                {{getMessage(18, 'leastappealing')}}
                </label>
                <textarea id="four-thing" type="text" v-model="form.leastappealing" rows="3"></textarea>
            </b-col>
        </b-row>
        <b-row class="mt-3 ">
            <b-col cols="12" >
                <label tabindex="0">
                   {{getMessage(18, 'career')}}
                </label>
            </b-col>
            <b-col cols="6 text-center emotion-content pr-2">
                <b-button block size="lg"  class="square" v-bind:class="{ active: form.answer === answers.NOANSWER, isCareerEntrep: isJACareerEntrepreApp }"
                     v-on:click="select(0)">
                    <span>No</span>
                </b-button>
            </b-col>
            <b-col cols="6 text-center emotion-content pr-2">
                <b-button block size="lg"  class="square" v-bind:class="{ active: form.answer === answers.YESANSWER, isCareerEntrep: isJACareerEntrepreApp }"
                    v-on:click="select(1)">
                    <span>Yes</span>
                </b-button>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import {Steps} from '../Utils'
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"

    const answers  = Object.freeze({
        NOANSWER: 0,
        YESANSWER: 1,
   })

    export default {

        name: "RapidExperimentsWithCustomers18",
        components: {ProjectStepContainer},
        data() {
            return {
                step: Steps.FORM_INTERVIEW_RESULTS,
                form: {
                    interview:"",
                    find: "",
                    mostappealing: "",
                    leastappealing: "" ,
                    answer: null,
                    disabledCareers: []
                } ,
                selectedCareers : []  ,
            }
        },
        created() {
            this.answers = answers
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
            this.selectedCareers = forms[Steps.FORM_CAREER].careersSelected
        },
        methods: {
            select(num) {
                const form = this.form
                form.answer = num
            },
            redirection(){
                const index = this.$route.params.index
                if(this.form.answer === 0 ){
                    if (this.selectedCareers.length === 3) {
                        this.$router.push({name: 'js_go_broad_to_go_narrow_other_24', params: { index }})
                    } else {
                        this.$router.push({name: 'time_to_reset_25', params: { index }})
                    }
                }
                else if (this.form.answer === 1 ) {
                    this.$router.push({name: 'js_rapid_experiments_with_customers_19', params: { index }})
                }
            },
            updateProject() {
                if(this.form.answer === 0 ){
                    this.form.disabledCareers  = this.selectedCareers
                }
                const index = this.$route.params.index
                const stepNumber = Steps.getStepFromForm(this.step)

                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
        }

    }
</script>


<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
    .word-highlighted
        color color-9
    .high-contrast
        .square
            border 1px solid  color-4
            box-shadow(0px 1px 5px color-16)
            color black
            &:hover
                border solid 1px color-29

            &.active
                background-color color-29
                color white


    .square
        font-family 'Source Sans Pro', sans-serif
        font-size 16px
        font-weight 400
        color color-4
        border-radius 10px
        box-shadow(0px 1px 5px color-16)
        height 69px
        margin-top 15px

        &:hover
            border solid 1px color-5

        &.active
            background-color color-5
            color white

    .table-t
        display table
        height 69px
        width 100%

    .text-t
        display table-cell
        vertical-align middle
</style>
